import type { AppDispatch } from '../store/store';
import { refreshToken } from '../store/features/auth';

let refreshInFlight: ReturnType<AppDispatch> | null = null;

/** Dedupe silent refresh during app bootstrap (React StrictMode, concurrent mounts). */
export function refreshTokenOnce(dispatch: AppDispatch): ReturnType<AppDispatch> {
  if (refreshInFlight) {
    return refreshInFlight;
  }

  refreshInFlight = dispatch(refreshToken());
  void Promise.resolve(refreshInFlight).finally(() => {
    refreshInFlight = null;
  });

  return refreshInFlight;
}

/** Test helper */
export function resetAuthBootstrapInflightForTests(): void {
  refreshInFlight = null;
}
